var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExit = function SvgExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.492 9 3.057 4-3.057 4M17 3H5a1 1 0 0 0-1 1v17.5a1 1 0 0 0 1 1h12M11 13h10",
    stroke: "#7D80DA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
export { SvgExit as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Im0xOS40OTIgOSAzLjA1NyA0LTMuMDU3IDRNMTcgM0g1YTEgMSAwIDAgMC0xIDF2MTcuNWExIDEgMCAwIDAgMSAxaDEyTTExIDEzaDEwIiBzdHJva2U9IiM3RDgwREEiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=";